import { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import Alert from '@mui/material/Alert'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectActiveBuildingId } from '@/features/building/buildingSlice'
import { usePostWriteOffMutation } from '@/api/billing'
import { closeRemoveDebtModal, selectShowRemoveDebtModal } from '../billingSlice'

const RemoveDebtModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const show = useSelector(selectShowRemoveDebtModal);
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const [writeOff, { 
    isLoading, 
    isSuccess,
    isError,
    error, 
    reset 
  }] = usePostWriteOffMutation()
  const [plateNumber, setPlateNumber] = useState('')
  const handleChange = ({ target }) => {
    setPlateNumber(target.value)
  }
  
  const postWriteOff = async () => {
    try {
      await writeOff({
        building_id: activeBuildingId,
        plateNumber
      }).unwrap()
      // setOpen(false)
    } catch (e) {
      // setOpen(false)
      console.error(e)
    }
  }

  const closeModalHandler = () => {
    dispatch(closeRemoveDebtModal())
    reset()
  }

  return (
    <Dialog 
      open={show} 
      onClose={closeModalHandler}
    >
      <DialogTitle>{t('close_debt')}</DialogTitle>
      <DialogContent>
        {
          isSuccess || isError ? (
            <Alert 
              severity={isSuccess ? 'success' : 'error'}
              sx={{
                whiteSpace: 'pre-line',
                lineHeight: '1',
              }}
            >
              {
                isSuccess 
                  ? t('operation_successful') 
                  : (error?.data?.message || t('unknown_error'))
              }
            </Alert>
          ) : (
            <DialogContentText>
              {t('enter_number_to_continue')}
            </DialogContentText>
          )
        }
        <TextField
          onChange={handleChange}
          value={plateNumber}
          autoFocus
          margin="dense"
          id="govNumber"
          label={t('plate_number')}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModalHandler} color="error">
          {t('close')}
        </Button>
        <Button
          loading={isLoading}
          disabled={plateNumber.length < 3}
          onClick={postWriteOff}
        >
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveDebtModal